import { FC, memo } from 'react';
import { StockFilterForm, IStockFilterForm } from './StockFilterForm';

export const StockFilter: FC<IStockFilterForm> = memo((props) => <StockFilterForm {...props} />);
